import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { LoginPage, RegisterPage } from '@/pages/auth'
import { DashboardPage } from '@/pages/dashboard'
import MarketplacePage from '@/pages/marketplace/MarketplacePage'
import ListingDetailPage from '@/pages/marketplace/ListingDetailPage'
import ProfilePage from '@/pages/profile/ProfilePage'
import AdminLoginPage from '@/pages/admin/AdminLoginPage'
import AdminDashboardPage from '@/pages/admin/AdminDashboardPage'
import AnalyticsPage from '@/pages/admin/AnalyticsPage'
import BulkImportPage from '@/pages/admin/BulkImportPage'
import { ProtectedRoute, AdminRoute } from '@/components/auth'
import { MainLayout } from '@/components/layout'

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        
        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route 
          path="/admin/dashboard" 
          element={
            <AdminRoute>
              <AdminDashboardPage />
            </AdminRoute>
          } 
        />
        <Route 
          path="/admin/analytics" 
          element={
            <AdminRoute>
              <AnalyticsPage />
            </AdminRoute>
          } 
        />
        <Route 
          path="/admin/bulk-import" 
          element={
            <AdminRoute>
              <BulkImportPage />
            </AdminRoute>
          } 
        />
        
        {/* Public marketplace routes */}
        <Route 
          path="/marketplace" 
          element={
            <MainLayout>
              <MarketplacePage />
            </MainLayout>
          } 
        />
        <Route 
          path="/marketplace/:slug" 
          element={
            <MainLayout>
              <ListingDetailPage />
            </MainLayout>
          } 
        />
        
        {/* Protected routes */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <MainLayout>
                <DashboardPage />
              </MainLayout>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/profile" 
          element={
            <ProtectedRoute>
              <MainLayout>
                <ProfilePage />
              </MainLayout>
            </ProtectedRoute>
          } 
        />
        
        {/* Redirects */}
        <Route path="/" element={<Navigate to="/marketplace" replace />} />
        <Route path="*" element={<Navigate to="/marketplace" replace />} />
      </Routes>
    </Router>
  )
}

export default App
